export default "__VITE_ASSET__DoZSLPqW__"